import React from 'react';
import { View, Pressable, Platform } from 'react-native';
import { useTheme } from '@/context/ThemeContext';
import Text from '@/components/Typography/Text';
import Icon from '@/components/Icon';
import { PLUS_COLORS } from '@/constants/Colors';

const Badge = ({ text, icon, isPlus, isSmall, isLarge, onPress, style, iconColor, textColor = 'alt', solid = false, backgroundColor }) => {
  const { colors } = useTheme();

  const baseStyle = {
    height: isLarge ? 24 : isSmall ? 16 : 18,
    minWidth: isLarge ? 24 : 18,
    paddingHorizontal: !text ? 2 : 6,
    borderRadius: 4,
    justifyContent: 'center',
    alignItems: 'center',
    flexDirection: 'row',
    gap: 4,
    backgroundColor: isPlus ? PLUS_COLORS.backgroundImage : backgroundColor || colors.solid_color_toast,
    ...(Platform.OS === 'web' && { backgroundImage: isPlus ? PLUS_COLORS.backgroundImage : undefined }),
  };

  const textStyle = {
    textShadow: isPlus ? PLUS_COLORS.textShadow : undefined,
    marginLeft: isLarge ? 3 : 0,
  };
  
  const isSolid = isPlus ? true : solid;
  const theIconColor = isPlus ? PLUS_COLORS.iconColor : iconColor || colors.text_color_primary;
  const theTextColor = isPlus ? PLUS_COLORS.textColor : textColor || colors.text_color_alt;
  const theTextWeight = isPlus ? 'extraBold' : 'medium';
  const theTextSize = isLarge ? 'm' : isSmall ? 'xxs' : 'xs';
  const theIconSize = isLarge ? 12 : isSmall ? 10 : 12;
  if (isPlus) {
    icon = 'sparkles';
  }

  if (!icon && !text) return null;

  if (!onPress) {
    return (
      <View style={[baseStyle, style]}>
        {!!icon && <Icon name={icon} solid={isSolid} size={theIconSize} color={theIconColor} />}
        {!!text && <Text size={theTextSize} color={theTextColor} weight={theTextWeight} style={textStyle}>{text}</Text>}
      </View>
    );
  }

  return (
    <Pressable 
      onPress={onPress}
      style={({ hovered }) => [
        baseStyle,
        style,
      ]}
    >
      {icon && <Icon name={icon} size={theIconSize} solid={isSolid} color={theIconColor} />}
      {text && <Text size={theTextSize} color={theTextColor} weight={theTextWeight} style={textStyle}>{text}</Text>}
    </Pressable>
  );
};

export default Badge; 